module.exports = __webpack_public_path__ + "img/hummel.a659d471.png";